var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRowHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 353.404 355"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 25"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 21"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 117",
  d: "M343.01 56.855h-159.3l-7.008 5.111v241.032a10.4 10.4 0 0010.394 10.4H343.01a10.4 10.4 0 0010.394-10.4V67.255a10.4 10.4 0 00-10.394-10.4z",
  fill: "#f8e5ca"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 118",
  d: "M343.01 56.855h-77.957v256.543h77.957a10.4 10.4 0 0010.394-10.4V67.255a10.4 10.4 0 00-10.394-10.4z",
  fill: "#ffd38f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 119",
  d: "M285.841 313.398h-41.577a10.4 10.4 0 01-10.394-10.4v-48.537a31.183 31.183 0 1162.365 0v48.535a10.4 10.4 0 01-10.394 10.402z",
  fill: "#766e6e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 120",
  d: "M285.841 313.398a10.4 10.4 0 0010.394-10.4v-48.537a31.227 31.227 0 00-31.182-31.2v90.137z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 121",
  d: "M254.659 313.398h20.788v-58.936a10.394 10.394 0 10-20.788 0z",
  fill: "#a8ebfa"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 122",
  d: "M265.053 244.062v69.336h10.394v-58.936a10.409 10.409 0 00-10.394-10.4z",
  fill: "#6cd8f8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 123",
  d: "M176.702 181.66h176.7v20.8h-176.7z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 124",
  d: "M306.63 91.523h-83.154a10.4 10.4 0 00-10.394 10.4v41.6a10.4 10.4 0 0010.394 10.4h83.154a10.4 10.4 0 0010.394-10.4v-41.6a10.4 10.4 0 00-10.394-10.4z",
  fill: "#766e6e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 125",
  d: "M317.024 143.523v-41.6a10.4 10.4 0 00-10.394-10.4h-41.577v62.4h41.577a10.4 10.4 0 0010.394-10.4z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 126",
  d: "M233.87 112.324h20.788v20.8H233.87z",
  fill: "#a8ebfa"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 127",
  d: "M275.447 112.324h20.788v20.8h-20.788z",
  fill: "#6cd8f8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 128",
  d: "M176.702 302.998v52H343.01a10.4 10.4 0 0010.392-10.4v-41.6z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 129",
  d: "M265.053 302.998v52h77.957a10.4 10.4 0 0010.394-10.4v-41.6z",
  fill: "#e20059"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 20"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 130",
  d: "M265.053 181.66h88.351v20.8h-88.351z",
  fill: "#e20059"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 131",
  d: "M318.756 58.704a10.4 10.4 0 01-10.394-10.4V11.786a10.394 10.394 0 1120.788 0v36.518a10.4 10.4 0 01-10.394 10.4z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 132",
  d: "M349.428 59.085c-.1-.078-.193-.16-.3-.234L271.175 1.999a10.389 10.389 0 00-12.245 0l-75.22 54.859-7.008 5.108h175.236a10.452 10.452 0 00-2.511-2.881z",
  fill: "#ed6c7b"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 133",
  d: "M351.938 61.967a10.484 10.484 0 00-2.511-2.881c-.1-.078-.193-.16-.3-.234L271.175 2a10.371 10.371 0 00-6.122-2v61.967z",
  fill: "#e20059"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 24"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 134",
  d: "M142.054 58.705a10.4 10.4 0 01-10.394-10.4V11.787a10.394 10.394 0 1120.788 0v36.518a10.4 10.4 0 01-10.394 10.4z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 135",
  d: "M7.008 56.856l-2.736 2A10.4 10.4 0 000 67.256v246.143h176.7V61.967z",
  fill: "#f8e5ca"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 22"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 136",
  d: "M176.702 61.972l-88.351-2.666v254.093h88.351z",
  fill: "#ffd38f"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 137",
  d: "M94.474 2.001a10.389 10.389 0 00-12.245 0L7.009 56.856l-2.736 2c-.1.075-.2.157-.3.234a10.484 10.484 0 00-2.511 2.881h175.24z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 138",
  d: "M109.139 313.399H67.562a10.4 10.4 0 01-10.394-10.4v-48.537a31.183 31.183 0 1162.365 0v48.535a10.4 10.4 0 01-10.394 10.402z",
  fill: "#766e6e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 139",
  d: "M109.139 313.399a10.4 10.4 0 0010.394-10.4v-48.537a31.227 31.227 0 00-31.182-31.2v90.137z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 140",
  d: "M77.957 313.399h20.788v-58.936a10.394 10.394 0 10-20.788 0z",
  fill: "#a8ebfa"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 141",
  d: "M88.351 244.063v69.336h10.394v-58.936a10.409 10.409 0 00-10.394-10.4z",
  fill: "#6cd8f8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 142",
  d: "M0 181.661h176.7v20.8H0z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 143",
  d: "M129.928 91.524H46.774a10.4 10.4 0 00-10.394 10.4v41.6a10.4 10.4 0 0010.394 10.4h83.154a10.4 10.4 0 0010.394-10.4v-41.6a10.4 10.4 0 00-10.394-10.4z",
  fill: "#766e6e"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 144",
  d: "M140.322 143.524v-41.6a10.4 10.4 0 00-10.394-10.4H88.351v62.4h41.577a10.4 10.4 0 0010.394-10.4z",
  fill: "#5b5555"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 145",
  d: "M57.168 112.325h20.788v20.8H57.168z",
  fill: "#a8ebfa"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 146",
  d: "M98.745 112.325h20.788v20.8H98.745z",
  fill: "#6cd8f8"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 147",
  d: "M0 302.999v41.6a10.4 10.4 0 0010.394 10.4H176.7v-52z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 23",
  fill: "#ffb454"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 148",
  d: "M88.351 302.998h88.351v52H88.351z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 149",
  d: "M88.351 181.66h88.351v20.8H88.351z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 150",
  d: "M94.473 2a10.374 10.374 0 00-6.122-2v61.967h88.351z"
}))))));
export default SvgRowHouse;